import { render } from "./ExamView.vue?vue&type=template&id=9da085e8&ts=true"
import script from "./ExamView.vue?vue&type=script&lang=ts"
export * from "./ExamView.vue?vue&type=script&lang=ts"

import "./ExamView.vue?vue&type=style&index=0&id=9da085e8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__